import { Disclosure } from '@headlessui/react';
import { useCallback, useState } from 'react';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Input } from '../../../../core/components/atoms/Input';
import InnerHTMLContainer from '../../../../core/components/molecules/InnerHTMLContainer';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../../../../core/components/templates/Modal';
import { format } from 'date-fns';

interface CourseProgramModalProps {
  programsData: any[];
  isOpen: boolean;
  onClose: () => void;
  courseTitle: string;
  courseKind: string;
}

function CourseProgramModal({
  isOpen,
  onClose,
  programsData,
  courseTitle,
  courseKind,
}: CourseProgramModalProps) {
  const [programs, setPrograms] = useState(programsData);
  const [filterValue, setFilterValue] = useState('');

  const filterProgramsByContent = useCallback(
    (text: string) => {
      return programsData.filter((program) => {
        return program.description.toLowerCase().includes(text.toLowerCase());
      });
    },
    [filterValue]
  );

  function handleFilterChange(e: React.ChangeEvent<HTMLInputElement>) {
    setFilterValue(e.target.value);
    if (e.target.value) {
      setPrograms(filterProgramsByContent(e.target.value));
    } else {
      setPrograms(programsData);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      position='top-right'
      title='Ementa'
      subtitle={courseTitle}
      className={`
        m-0 
        mt-[10vh] 
        min-h-[90vh] 
        max-w-full
        
        rounded-b-none 
        md:m-4 
        md:min-h-[calc(100%-2rem)] 
        md:max-w-lg
        md:rounded-b-lg
      `}
    >
      <Input
        IconLeft={{
          Icon: 'search',
          type: 'material',
          className: 'text-mono-color-dark',
        }}
        label='Encontrar conteúdo'
        value={filterValue}
        onChange={handleFilterChange}
        className='mb-1'
      />

      {programs.map((week) => (
        <Disclosure key={week._id}>
          {({ open }) => (
            <>
              <Disclosure.Button className='flex w-full justify-between p-2 py-3'>
                <Typography
                  type='title'
                  size='h4'
                  className='flex items-center gap-4'
                >
                  {week.title}
                  {courseKind === 'regular' && (
                    <Typography size='small' variant='italic'>
                      {format(new Date(week.startDate), 'dd/MM/yyyy')}
                    </Typography>
                  )}
                </Typography>
                <Icon
                  type='material'
                  Icon={'chevron_right'}
                  className={`text-mono-color-black ${open ? 'rotate-90 transform' : ''}`}
                />
              </Disclosure.Button>

              <Disclosure.Panel className='px-2 pb-3'>
                <InnerHTMLContainer
                  data={week.description}
                  align='left'
                  type='courseProgram'
                  className='text-mono-color-darkest'
                />
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
      ))}
    </Modal>
  );
}

export { CourseProgramModal };
